// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rpoE","content":"styles_content__2scPQ"};